import { render, staticRenderFns } from "./editOwnerMember.vue?vue&type=template&id=e63951b6&scoped=true"
import script from "./editOwnerMember.vue?vue&type=script&lang=js"
export * from "./editOwnerMember.vue?vue&type=script&lang=js"
import style0 from "./editOwnerMember.vue?vue&type=style&index=0&id=e63951b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e63951b6",
  null
  
)

export default component.exports